import { Component, EventEmitter, Input, OnInit, Output, ViewChild, Renderer2, ElementRef  } from '@angular/core';
import { NgbCalendar, NgbDateParserFormatter, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { VehicleService } from 'src/app/core/services/vehicle.service';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { IUser } from 'src/app/core/models/user.model';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vehicles-search-fields',
  templateUrl: './vehicles-search-fields.component.html',
  styleUrls: ['./vehicles-search-fields.component.css']
})
export class VehiclesSearchFieldsComponent implements OnInit {

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  moreOptions = false;
  toggleDateError = false;
  fromDateSearch = '';
  toDateSearch = '';
  processingStatus: string[] = [];
  vehicleStatus: string = '';
  selectedStatus: number;
  vinSearch = '';
  totalImages: number = null;
  clientId: string;
  isLoading = false;
  isLoadingImages = false;
  currentUser: IUser = null;

  useremailSearch
  usernameSearch
  clientNameSearch
  licensePlateNumber

  showList: boolean = false;
  selectItem: string = "With all subcustomers";
  childId: string;
  allChildIds: boolean = true;

  customerId: string;
  selectedCustomer: any;

  @Input() areCustomerVehicles: boolean = false;
  @Input() areClientVehicles: boolean = false;
  @Input() subcustomers = [];
  @Input() initialData: any;
  @Output() onSearch = new EventEmitter<Object>();

  @ViewChild('toggleSelectList') toggleSelectList: ElementRef;
  @ViewChild('list') list: ElementRef;

  customers: any;

  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private vehicleService: VehicleService,
    private authService: AuthService,
    private renderer: Renderer2,
    private customerService: CustomerService,
    public router: Router,
  ) { 
    this.renderer.listen('window', 'click', (e: Event) => {
      if(e.target !== this.toggleSelectList?.nativeElement && e.target!==this.list?.nativeElement){
        this.showList=false;
    }
    });
  }

  ngOnInit(): void {
    this.authService.LoggedinUser
      .pipe(
        take(1))
      .subscribe(user => {
        this.currentUser = user;
        this.clientId = user.clientId;
        if(this.currentUser.role.name === 'root') {
          this.customerService.getAll().subscribe(res => {
            this.customers = res
            if (this.initialData?.customerId) {
              this.selectedCustomer = this.customers.find(customer => customer.id === this.initialData.customerId);
            }
          })
        }
      });
    if (this.initialData) {
      const toDate = this.initialData.to ? new Date(this.initialData.to.year, this.initialData.to.month-1, this.initialData.to.day-1, 0, 0, 0) : null;
      this.fromDate = this.initialData.from || null;
      this.toDate = this.validateInput(this.toDate, moment(toDate).format('YYYY-MM-DD')) || null;
      this.usernameSearch = this.initialData.name;
      this.useremailSearch = this.initialData.email;
      this.searchVins = this.initialData.vins || [];
      this.clientNameSearch = this.initialData.clientName || null;
      this.licensePlateNumber = this.initialData.licensePlateNumber || null;
      this.vehicleStatus = this.initialData.vehicleStatus || "";
      this.allChildIds = this.initialData.allChildIds || null;
      this.customerId = this.initialData.customerId || null;
    }
  }

  searchVehicles(vin?: boolean) {
    if (this.vinSearch && this.vinSearch.length) {
      const vin = this.searchVins.some(vin => vin === this.vinSearch);

      if (!vin) {
        this.searchVins.push(this.vinSearch);
      }

      this.vinSearch = '';
    }

    if (vin && !this.areDatesValid()) {
      return;
    }

    this.onSearch.emit({
      from: this.fromDateSearch,
      to: this.toDateSearch,
      searchVins: this.searchVins,
      name: this.usernameSearch || undefined,
      email: this.useremailSearch || undefined,
      isVin: vin || false,
      childId: this.childId || undefined,
      allChildIds: this.allChildIds,
      clientName: this.clientNameSearch || undefined,
      licensePlateNumber: this.licensePlateNumber || undefined,
      vehicleStatus: this.vehicleStatus || undefined,
      customerId: this.customerId || undefined
    });
  }

  areDatesValid(): boolean {
    const from = (document.getElementById('fromDate') as HTMLInputElement).value;
    let d = '';
    if (from !== '') {
      let fromDate = moment(from, ["YYYY-MM-DD", "YYYY/MM/DD", "YYYY.MM.DD"], true);
      if (!fromDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      this.fromDateSearch = new Date(fromDate.format('YYYY-MM-DD')).toISOString();
    } else {
      this.fromDateSearch = undefined;
      this.fromDate = null;
    }

    const to = (document.getElementById('toDate') as HTMLInputElement).value;
    let t = '';
    if (to !== '') {
      let toDate = moment(to, ["YYYY-MM-DD", "YYYY/MM/DD", "YYYY.MM.DD"], true);
      if (!toDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      t = new Date(toDate.format('YYYY-MM-DD')).toISOString();
      this.toDateSearch = t.substring(0, t.indexOf('T') + 1) + '23:59:59.000Z';
    } else {
      this.toDateSearch = undefined;
      this.toDate = null;
    }

    return true;
  }

  @ViewChild('datepicker', { static: false }) ngbDatepicker
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate) {
      this.toDate = date;

      // TODO: Automatski zatvori kad selektuje toDate
      this.ngbDatepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  lastWeek() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
    this.toDate = this.calendar.getToday();
  }

  lastMonth() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'm', 1);
    this.toDate = this.calendar.getToday();
  }

  showMoreOptions() {
    this.moreOptions = !this.moreOptions;

    const options = document.querySelector('.search-fields') as HTMLElement;
    const fields = Array.from(document.querySelectorAll('.select'));

    if (this.moreOptions) {
      options.classList.add('show-options');
      fields.forEach(field => {
        field.classList.add('visible');
      });
    } else {
      options.classList.remove('show-options');
      fields.forEach(field => {
        field.classList.remove('visible');
      });
    }
  }

  countImages() {
    const from = (document.getElementById('fromDate') as HTMLInputElement).value;
    let d = '';
    if (from !== '') {
      let fromDate = moment(from, ["YYYY-MM-DD", "YYYY/MM/DD", "YYYY.MM.DD"], true);
      if (!fromDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      d = new Date(fromDate.format('YYYY-MM-DD')).toISOString();
    }

    const to = (document.getElementById('toDate') as HTMLInputElement).value;
    let t = '';
    if (to !== '') {
      let toDate = moment(to, ["YYYY-MM-DD", "YYYY/MM/DD", "YYYY.MM.DD"], true);
      if (!toDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      t = new Date(toDate.format('YYYY-MM-DD')).toISOString();
      t = t.substring(0, t.indexOf('T') + 1) + '23:59:59.000Z';
    }

    this.isLoadingImages = true;
    this.vehicleService.getClientTotalImages(this.clientId, d, t)
      .subscribe(
        res => {
          this.totalImages = res.count;
          this.isLoadingImages = false;
        },
        err => {
          this.isLoadingImages = false;
        }
      );
  }

  removeProcessingStatus(status) {
    if (this.processingStatus.indexOf(status) != -1) {
      this.processingStatus.splice(this.processingStatus.indexOf(status), 1);
    }
  }

  /*selectStatus(status) {
    this.processingStatus = status;
  }*/

  searchVins: any[] = [];
  addVin() {
    if (!this.vinSearch || !this.vinSearch.length) {
      return;
    }

    this.searchVins.push(this.vinSearch);
    this.vinSearch = '';
    this.searchVehicles();
  }

  removeVin(removeVin) {
    this.searchVins = this.searchVins.filter(vin => vin !== removeVin);
    this.searchVehicles();
  }

  searchSubcustomer(id?:string, name?:string, allChildIds?:boolean) {
    this.showList = false;
    this.childId = id;
    this.selectItem = name;
    this.allChildIds = allChildIds;
    this.searchVehicles(true)
  }

  onCustomerSelect(customer) {
    if (customer) {
      this.customerId = customer.id;
    } else {
      this.customerId = undefined;
    }
  }
}

/*const initialStatuses = [
  { id: 1, name: 'completed' },
  { id: 2, name: 'failed' },
  { id: 3, name: 'pending' },
  { id: 4, name: 'processing' },
  { id: 5, name: 'qc' },
  { id: 6, name: 'unprocessed' },
]*/